<component class="Entity" :is="tag" :class="classes" v-on="$attrs"><slot v-if="item"></slot></component>